export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS";
export const SIGN_OUT_SUCCESS = "SIGN_OUT_SUCCESS";

export const GET_DOCTYPES_LOADING = "GET_DOCTYPES_LOADING";
export const GET_TYPEDOCS_SUCCESS = "GET_TYPEDOCS_SUCCESS";
export const GET_TYPEDOCS_FAILURE = "GET_TYPEDOCS_FAILURE";
